import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import {useDifactoBucket} from "../../../components/utils";
import AudienceForm from "../../../components/data_products/audiences/AudienceForm";
import { useGetAudiencesQuery,
  useGetAudienceAggregationOptionsQuery,
  useCreateAudienceMutation
} from "../../../api/audienceApiSlice";

function NewAudience(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const bucket = useDifactoBucket();
  const { data: aggregationOptions = [] } = useGetAudienceAggregationOptionsQuery()
  const { data: audiences = [] } = useGetAudiencesQuery()

  const goToAudience = (data) => history.push(`/audiences/${data.key}`)

  const [newAudience] = useCreateAudienceMutation()

  const submitProps = {
    handleSubmit: (data) => {
      newAudience(data).unwrap()
        .then(goToAudience)
        .catch(error => {})
    },
    errors: {}
  }

  return (
    <>
      <Title
        main={t("menu.audiences")}
        sub={t("new")}
        group={false}
        backPath="/audiences">
        <FormButton submit {...submitButtonProps}/>
      </Title>
      <AudienceForm
        bucket={bucket}
        {...submitProps}
        setSubmitButtonProps={setSubmitButtonProps}
        audiences={audiences}
        aggregationOptions={aggregationOptions}/>
    </>
  )
}

export default NewAudience
